<template>
<div>
  <b-container>
    <b-row>
      <b-col cols="12">
        <b-card class="mintCard">
          <h2 class="mintTitle">MINT</h2>
          <br>
          <video class="nftVid" playsinline autoplay muted loop>
            <source src="../../assets/nft.mp4" type="video/mp4">
          </video>
          <br>
          <h4 class="mintSubtitle">{{totalSupply}} / 333 Minted</h4>
          <br>
          <div v-if="WLOpen && walletAddress">
            <button v-if="!loadingTransaction" @click="mintOmegaOG" class="button-29" role="button">OG MINT</button>
            <button v-if="!loadingTransaction" @click="mintOmegaWL" class="button-29" role="button">WL MINT</button>
          </div>
          <div v-if="!WLOpen && PublicOpen && walletAddress">
            <button v-if="!loadingTransaction" @click="mintOmega" class="button-29" role="button">Public MINT</button>
          </div>
          <button v-if="!walletAddress" @click="LoadEthWallet" class="button-29" role="button">Connect Wallet</button>
          <b-icon v-if="loadingTransaction" icon="arrow-clockwise" animation="spin" font-scale="4"></b-icon> 
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
import Web3 from 'web3';
import MerkleTree from 'merkletreejs';
import Keccak256 from 'keccak256';
import contract from '../../assets/contract.json'
import whitelistFileOG from '../../assets/ogWhitelist.json'
import whitelistFile from '../../assets/wlWhitelist.json'
export default {
    data: function () {
            return {
                walletAddress: '',
                walletBalance: '',

                web3: '',

                omegaContract: '',
                contractAddress: contract.contractAddress,
                contractABI: contract.abi,


                merkleTree: MerkleTree,
                keccak256: Keccak256,


                whitelistOG: whitelistFileOG,
                whitelistWL: whitelistFile,
                loadingTransaction: false,

                totalSupply: 0,

                ogPrice: 0.066,
                wlPrice: 0.077,
                publicPrice: 0.088,


                WLOpen : false,
                PublicOpen: false,
            }
    },
    mounted()
    {

    },
    methods:{
       
      mintOmegaWL()
        {
            const leafNodes = this.whitelistWL.map(addr => keccak256(addr));
            const tree = new this.merkleTree(leafNodes, this.keccak256, { sortPairs: true});
            
            const root = tree.getRoot();
            var indexForMsgSender = this.whitelistWL.indexOf(this.walletAddress);
            if(indexForMsgSender >= 0)
            {
            }
            else
            {
              indexForMsgSender = this.whitelistWL.indexOf(this.walletAddress.toLowerCase());
            }
            if(indexForMsgSender >= 0)
              {

                this.loadingTransaction = true;
                const claimingAccount = leafNodes[indexForMsgSender];
                const hexProof = tree.getHexProof(claimingAccount);
                const weiValue = this.web3.utils.toWei((this.wlPrice).toString(), 'ether');

                this.omegaContract.methods.whitelistWL(hexProof).send({from: this.walletAddress, value: weiValue})
                .on('confirmation', function(confirmationNumber, receipt)
                {
                    
                })
                .then(res=>{
                    this.LoadContract();
                    this.loadingTransaction = false;
                })
                .catch(err=>{
                    this.LoadContract();
                    this.loadingTransaction = false;
                })
              }
              else
              {
                alert("You are not whitelisted")
              }
          
        },
        mintOmegaOG()
        {
            const leafNodes = this.whitelistOG.map(addr => keccak256(addr));
            const tree = new this.merkleTree(leafNodes, this.keccak256, { sortPairs: true});
            
            const root = tree.getRoot();
            var indexForMsgSender = this.whitelistOG.indexOf(this.walletAddress);
            if(indexForMsgSender >= 0)
            {
            }
            else
            {
              indexForMsgSender = this.whitelistOG.indexOf(this.walletAddress.toLowerCase());
            }
            if(indexForMsgSender >= 0)
              {

                this.loadingTransaction = true;
                const claimingAccount = leafNodes[indexForMsgSender];
                const hexProof = tree.getHexProof(claimingAccount);
                const weiValue = this.web3.utils.toWei((this.ogPrice).toString(), 'ether');

                this.omegaContract.methods.whitelistOG(hexProof).send({from: this.walletAddress, value: weiValue})
                .on('confirmation', function(confirmationNumber, receipt)
                {
                    
                })
                .then(res=>{
                    this.LoadContract();
                    this.loadingTransaction = false;
                })
                .catch(err=>{
                    this.LoadContract();
                    this.loadingTransaction = false;
                })
              }
              else
              {
                alert("You are not on the OG whitelist")
              }
          
        },
        mintOmega()
        {
          this.loadingTransaction = true;
          const weiValue = this.web3.utils.toWei((this.publicPrice).toString(), 'ether');

          this.omegaContract.methods.publicSale().send({from: this.walletAddress, value: weiValue})
          .on('confirmation', function(confirmationNumber, receipt)
          {
              
          })
          .then(res=>{
              this.LoadContract();
              this.loadingTransaction = false;
          })
          .catch(err=>{
              this.LoadContract();
              this.loadingTransaction = false;
          })
        },
        async chainChange()
        {
            await window.ethereum.request({
                        method: 'wallet_switchEthereumChain',
                        params: [{ chainId: '0x1' }], // chainId must be in hexadecimal numbers
                    });
            this.LoadEthWallet();
        },
        LoadEthWallet: function(){
          if (typeof window.ethereum !== 'undefined') 
          {
            this.web3 = new Web3(window.ethereum || new Web3.providers.HttpProvider("https://mainnet.infura.io/v3/1xVMLkEDl6htSmYN7YeFXGvIe07") || Web3.givenProvider);
            this.web3.eth.net.getNetworkType()
            .then(network=>{
              if(network == "main")
              {
                
                this.web3.eth.requestAccounts()
                  .then(acc=>{
                    this.walletAddress = acc[0];
                    this.web3.eth.getBalance(this.walletAddress)
                      .then(balance=>{
                        this.walletBalance = this.web3.utils.fromWei(balance, "ether");
                        this.LoadContract();     
                      });
                    })
                    .catch(err=>{
                      console.log(err);
                    })            
              }
              else{
                this.chainChange();
              }          
            })
          }
        },
        LoadContract: function()
        {
          this.omegaContract = new this.web3.eth.Contract(this.contractABI, this.contractAddress);
          this.omegaContract.methods.WLOpen().call({from: this.walletAddress})
          .then(res=>{
            this.WLOpen = res;
          })
          this.omegaContract.methods.PublicOpen().call({from: this.walletAddress})
          .then(res=>{
            this.PublicOpen = res;
          })

          this.omegaContract.methods.totalSupply().call({from: this.walletAddress})
          .then(res=>{
            this.totalSupply = res;
          })

        }
    }
}
</script>

<style scoped>
.mintCard
{
  background-color: transparent !important;

}
.nftVid
{
  width: 25vh;
}
.mintTitle
{
    font-size: 5vh;
    font-weight: 700;
    background: linear-gradient(180deg, rgba(255,237,101,1) 20%, rgba(215,148,61,1) 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -moz-background-clip: text;
    -webkit-text-fill-color: transparent; 
    -moz-text-fill-color: transparent;
}
.mintSubtitle
{
  margin-top: 1vh;
    font-weight: 700;
    background: linear-gradient(180deg, rgba(255,237,101,1) 20%, rgba(215,148,61,1) 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -moz-background-clip: text;
    -webkit-text-fill-color: transparent; 
    -moz-text-fill-color: transparent;
}

/* CSS */
.button-29 {
  align-items: center;
  appearance: none;
  background-image: linear-gradient(180deg, rgba(255,237,101,1) 20%, rgba(215,148,61,1) 100%);
  border: 0;
  border-radius: 6px;
  box-shadow: rgba(45, 35, 66, .4) 0 2px 4px,rgba(45, 35, 66, .3) 0 7px 13px -3px,rgba(58, 65, 111, .5) 0 -3px 0 inset;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  height: 48px;
  justify-content: center;
  line-height: 1;
  list-style: none;
  overflow: hidden;
  padding-left: 16px;
  padding-right: 16px;
  position: relative;
  text-align: left;
  text-decoration: none;
  transition: box-shadow .15s,transform .15s;
  white-space: nowrap;
  will-change: box-shadow,transform;
  font-size: 18px;
}

.button-29:focus {
  box-shadow: rgba(255,237,101,1) 0 0 0 1.5px inset, rgba(45, 35, 66, .4) 0 2px 4px, rgba(45, 35, 66, .3) 0 7px 13px -3px, rgba(215,148,61,1) 0 -3px 0 inset;
}

.button-29:hover {
  box-shadow: rgba(45, 35, 66, .4) 0 4px 8px, rgba(45, 35, 66, .3) 0 7px 13px -3px, white 0 -3px 0 inset;
  transform: translateY(-2px);
}

.button-29:active {
  box-shadow: rgba(255,237,101,1) 0 3px 7px inset;
  transform: translateY(2px);
}
</style>


// WEBPACK FOOTER //
// src/components/homeComp/Mint.vue